import React from 'react';
import { useHistory } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import TopNav from 'components/layout-components/TopNav';
import MobileNav from 'components/layout-components/MobileNav'
import HeaderNav from 'components/layout-components/HeaderNav';
import Footer from 'components/layout-components/Footer';
import AppViews from 'views/app-views';
import {
  Layout,
  Grid,
} from 'antd';
import { Button } from 'antd';

import { LeftOutlined } from '@ant-design/icons';

import navigationConfig from 'configs/NavigationConfig';
import {
  SIDE_NAV_WIDTH,
  SIDE_NAV_COLLAPSED_WIDTH,
  NAV_TYPE_TOP,
  DIR_RTL,
  DIR_LTR
} from 'constants/ThemeConstant';
import utils from 'utils';
import { useThemeSwitcher } from 'react-css-theme-switcher';
import { Menu } from 'antd';
import { setLoading } from 'redux/actions/Loader';
import SettingsViews from 'views/app-views/settingsViews';

import { compose } from 'redux'

const { Content } = Layout;
const { useBreakpoint } = Grid;

export const SettingsLayout = ({ navCollapsed, navType, location, direction }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const currentRouteInfo = utils.getRouteInfo(navigationConfig, location.pathname)
  const screens = utils.getBreakPoint(useBreakpoint());
  const isMobile = !screens.includes('lg')
  const isNavTop = navType === NAV_TYPE_TOP
  const getLayoutGutter = () => {
    if (isNavTop || isMobile) {
      return 0
    }
    return navCollapsed ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH
  }

  const { status } = useThemeSwitcher();

  if (status === 'loading') {
    dispatch(setLoading({
      loading: true,
      cover: 'page'
    }))
    return null;
  }

  const getLayoutDirectionGutter = () => {
    if (direction === DIR_LTR) {
      return { paddingLeft: getLayoutGutter() }
    }
    if (direction === DIR_RTL) {
      return { paddingRight: getLayoutGutter() }
    }
    return { paddingLeft: getLayoutGutter() }
  }

  const handleClick = (e) => {
    history.push('/settings/' + e.key);
  };
  dispatch(setLoading({
    loading: false,
  }))

  return (
    <Layout>
      <HeaderNav isMobile={isMobile} />
      {(isNavTop && !isMobile) ? <TopNav routeInfo={currentRouteInfo} /> : null}
      <Layout className="ant-layout-has-sider app-container fix-mobile-menu">
        <Menu
          width={SIDE_NAV_WIDTH}
          onClick={handleClick}
          style={{ width: 256 }}
          defaultSelectedKeys={['1']}
          defaultOpenKeys={['sub1']}
          mode="inline"
          className={'app-settings-menu side-nav'}
        >
          <div className={'app-settings-back-link'}>
            <Button type="default" icon={<LeftOutlined />} onClick={() => history.push('/dashboard')} >
                            Back
            </Button>
          </div>
          <Menu.ItemGroup key="user-preferences" title="Your Preferences">
            <Menu.Item key="user-preferences/profile">Profile</Menu.Item>
            <Menu.Item key="user-preferences/notifications">Notifications</Menu.Item>
            <Menu.Item key="user-preferences/security">Security</Menu.Item>
          </Menu.ItemGroup>
          <Menu.ItemGroup key="account-setup" title="Account Setup">
            <Menu.Item key="account">Account Settings</Menu.Item>
            <Menu.Item key="clients">App Config</Menu.Item>  
            <Menu.Item key="clients">Contacts</Menu.Item>  
            <Menu.Item key="jobs">Notifications</Menu.Item> 
            <Menu.Item key="employees">Users</Menu.Item>
            <Menu.Item key="price-book">Price Book</Menu.Item> 
            <Menu.Item key="requests">Requests</Menu.Item>
            <Menu.Item key="quotes">Quotes</Menu.Item> 
            <Menu.Item key="invoices">Invoices</Menu.Item>
            {/*
                        <SubMenu key="sub3" title="Submenu">
                            <Menu.Item key="7">Option 7</Menu.Item>
                            <Menu.Item key="8">Option 8</Menu.Item>
                        </SubMenu>
                        */}
          </Menu.ItemGroup>
          {/*
                    <Menu.ItemGroup key="add-ons" title="Add Ons">
                        <Menu.Item key="time-tracking">Time Tracking</Menu.Item>
                        <Menu.Item key="expense-reporting">Expense Reporting</Menu.Item>
                    </Menu.ItemGroup>
                    */}
        </Menu>
        <Layout className="app-settings-layout app-layout fix-app-setting" style={getLayoutDirectionGutter()}>
          <div className={'app-content app-settings-content'}>
            <Content>
              <SettingsViews />
            </Content>
          </div>
          <Footer />
        </Layout>
      </Layout>
      {isMobile && <MobileNav />}
    </Layout>
  )
}

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType, locale } = theme;
  return { navCollapsed, navType, locale }
};

export default compose(connect(mapStateToProps))(React.memo(SettingsLayout)); 